import React, { useState } from 'react';
import AssignAdvisorModal from './AssignAdvisorModal';
import type { Notify } from './AssignAdvisorModal';
import { SHARED_STYLES } from '../styles';

interface Props {
  studentUuid: string;
  studentName: string;
  notify: Notify;
  // Reload the host after an assign / 409 so the new advisor shows.
  onDone: () => void;
}

// "Assign advisor" on a profile whose sales_advisor is null; the host gates it (useCanManageAdvisors canWrite).
function AssignAdvisorControl({ studentUuid, studentName, notify, onDone }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="rounded-md px-3 py-1.5 text-xs font-medium"
        style={SHARED_STYLES.SECONDARY_BTN}
      >
        Assign advisor
      </button>
      <AssignAdvisorModal
        student={open ? { uuid: studentUuid, name: studentName } : null}
        notify={notify}
        onClose={() => setOpen(false)}
        onDone={onDone}
      />
    </>
  );
}

export default AssignAdvisorControl;
